import { isPast } from 'date-fns';
import { useMemo } from 'react';

import { Milestone } from '../../apollo/__generated__/graphql';
import { useCurrentMilestone } from './useCurrentMilestone';

export const usePreviousMilestone = (milestones: Milestone[]) => {
  const currentMilestone = useCurrentMilestone(milestones);
  return useMemo(() => {
    const reverseMilestones = milestones.slice().reverse();
    return (
      reverseMilestones.find((milestone) => {
        if (milestone.id === currentMilestone?.id) {
          return false;
        }

        return isPast(milestone.endAt);
      }) ?? null
    );
  }, [milestones, currentMilestone]);
};
